import events from '@/services/events';
import logger from '@/services/logger';
import parseCapiError from '@/helpers/parse-capi-error';



const errorHandlers = {
  critical(error) {
    if (error.unauthorized || error.wasHandled) {
      return;
    }

    logger.error(error);

    const capiError = parseCapiError(error);

    if (capiError.messages.length > 0) {
      const message = capiError.messages.join(' ');

      events.emit('full-page-message', {
        title: 'Oops!',
        subtitle: message,
        description: 'We apologize for the inconvenience. Please try again later.'
      });
    }

    else {
      events.emit('full-page-message', {
        type: 'generic-error'
      });
    }

    error.wasHandled = true;
  },

  generic(error, options = {}) {
    if (error.unauthorized || error.wasHandled) {
      return;
    }

    logger.error(error);

    const capiError = parseCapiError(error);
    const messages = [
      ...capiError.messages
    ];

    if (messages.length === 0) {
      messages.push(options.fallbackMessage || 'Something went wrong. Please try again later.');
    }

    if (options.important) {
      events.emit('error', {
        messages
      });
    }

    else {
      messages.forEach((message) => {
        events.emit('notification', {
          clickToDismiss: true,
          message,
          type: 'error'
        });
      });
    }

    error.wasHandled = true;
  },

  ordering(error) {
    if (error.unauthorized || error.wasHandled) {
      return;
    }

    logger.error(error);

    const capiError = parseCapiError(error);

    events.emit('ordering-error', {
      capiErrorMessages: capiError.messages
    });

    error.wasHandled = true;
  },

  silent(error) {
    logger.error(error);
  }
};



export default errorHandlers;
